import React from 'react';
import PropTypes from 'prop-types';
import StandardItem from './equipment-code-association-form-elements/standard-item';
import StandardItemDescription from './equipment-code-association-form-elements/standard-item-description';
import { useEquipmentDetailCodes } from './equipment-code-detail-provider';
import AssociationSpecificationFields from '../../components/forms/association-specification-fields';

const AssociationForm = ({
  control,
  errors,
  register,
  setValue,
  updateStandardItemId,
  standardItemId,
}) => {
  const { equipmentAssociation, multipleOptions } = useEquipmentDetailCodes();

  const isNew = equipmentAssociation?.id === undefined;
  const isStandardItemInBetweenBidPeriods = isNew
    ? false
    : equipmentAssociation?.standardItem?.isStandardItemInBetweenBidPeriods;

  const canStandardItemPartialEdit =
    equipmentAssociation?.standardItem?.canPartialEdit;

  const isEqInContractYear =
    equipmentAssociation?.equipmentCode?.isEquipmentCodeContractYear;

  return (
    <>
      <StandardItem
        isNew={isNew}
        setStandardItemId={updateStandardItemId}
        control={control}
        errors={errors}
        register={register}
      />
      {isNew && standardItemId && (
        <StandardItemDescription standardItemId={standardItemId} />
      )}

      {!isNew && (
        <StandardItemDescription
          standardItemId={`${equipmentAssociation?.standardItem?.id}`}
        />
      )}

      <AssociationSpecificationFields
        control={control}
        errors={errors}
        setValue={setValue}
        equipmentAssociation={equipmentAssociation}
        multipleOptions={multipleOptions}
        isStandardItemInBetweenBidPeriods={isStandardItemInBetweenBidPeriods}
        canPartialEdit={canStandardItemPartialEdit}
        isInContractYear={isEqInContractYear}
        isNew={isNew}
      />
    </>
  );
};

AssociationForm.propTypes = {
  updateStandardItemId: PropTypes.func.isRequired,
  standardItemId: PropTypes.string.isRequired,
  errors: PropTypes.shape(Object).isRequired,
  control: PropTypes.shape(Object).isRequired,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default AssociationForm;
